import { Resource } from 'Generated/academy-graphql-types'
import { buildResourceLink } from '../utils'
import {
  AcademyResourceLink,
  TaskItemRowTitle,
} from './AcademyResourceTasks.styles'

type AcademyResourceTaskItemProps = {
  resource: Resource
  completed: boolean
  dispatchTaskAcademyLinkClicked: () => void
}

const AcademyResourceTaskItem = ({
  resource,
  completed,
  dispatchTaskAcademyLinkClicked,
}: AcademyResourceTaskItemProps) => {
  const onClickHandler = () => {
    dispatchTaskAcademyLinkClicked()
  }

  if (!resource) return null

  return (
    <AcademyResourceLink
      to={buildResourceLink(resource)}
      condition
      onClickHandler={() => {
        onClickHandler()
      }}
    >
      <TaskItemRowTitle completed={completed}>
        {resource.title}
      </TaskItemRowTitle>
    </AcademyResourceLink>
  )
}
export default AcademyResourceTaskItem
